import { Navigate } from "react-router-dom";
import PageLayout from "../PageLayout";
import LandingPage from "../pages/Landing";
import SlotGamesPage from "../pages/SlotGames";
import SlotGamesListPage from "../pages/SlotGamesList";
import SlotGameInfoPage from "../pages/SlotGameInfo";
import SlotGamePlayPage from "../pages/SlotGamePlay";
import FastGamesPage from "../pages/FastGames";
import FastGamesListPage from "../pages/FastGamesList";
import FastGamePlayPage from "../pages/FastGamePlay";
import WhyUsPage from "../pages/WhyUs";
import ServicesPage from "../pages/Services";
import ContactUsPage from "../pages/ContactUs";
import ProtectedRoute from "./ProtectedRoute";

const Redirect = ({ to }) => {
  return <Navigate to={to} />;
}

export const desktopRoutes = [
  {
    path: "/",
    element: <PageLayout />,
    children: [
      {
        index: true,
        element: <SlotGamesPage />,
      },
      {
        path: "slot-games-list",
        element: <ProtectedRoute element={<SlotGamesListPage />} />,
      },
      {
        path: "slot-game-info",
        element: <ProtectedRoute element={<SlotGameInfoPage />} />, // Protected
      },
      {
        path: "slot-game-play",
        element: <ProtectedRoute element={<SlotGamePlayPage />} />, // Protected
      },
      {
        path: "fast-games",
        element: <FastGamesPage />,
      },
      {
        path: "fast-games-list",
        element: <FastGamesListPage />,
      },
      {
        path: "fast-game-play",
        element: <FastGamePlayPage />,
      },
      {
        path: "why-us",
        element: <WhyUsPage />,
      },
      {
        path: "services",
        element: <ServicesPage />,
      },
      {
        path: "contact-us",
        element: <ContactUsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <Redirect to="/" />,
  },
]
